<template>
  <div>
    <list-page-view
      ref="dec"
      title="开票通知单"
      :needExport="true"
      :needColumn="true"
      :bodyStyle="{ 'min-height': '500px' }"
      searchHint="物料名称"
      @toExport="toExport"
      @toQuery="toQuery"
      @toReset="toReset"
      @toColumn="toColumn"
      @selectColumnOK="selectColumnOK"
      :needPrint="true"
      @toPrint="toPrint"
      @STSelectedDataKeys="STSelectedDataKeys"
    >
      <a-row :gutter="48" slot="contentfilter">
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">物料编码:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input placeholder="请输入物料编码" v-model="loadParams.cinvcode" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">供应商编码:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input placeholder="请输入供应商编码" v-model="loadParams.cvencode" :disabled="userinfo.cvencode ? true : false" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">供应商名称:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-input placeholder="请输入供应商名称" v-model="loadParams.cvenname" :disabled="userinfo.cvencode ? true : false" />
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row :gutter="48" slot="contentfilter">
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">单据编号:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm"><a-input placeholder="请输入单据编号" v-model="loadParams.ccode" required: true/></a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">单据日期:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-range-picker @change="handleChange" v-model="dddate" />
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">开票状态:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-select placeholder="请选择开票状态" v-model="loadParams.voucherstate" :allowClear="true">
                <a-select-option v-for="(item, index, key) in $store.getters.moduleEnums.scm.billState.data" :value="item.id" :key="key">{{
                  item.text
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row :gutter="48" slot="contentfilter">
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">采购类型:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-select placeholder="采购类型" v-model="loadParams.cptname" :allowClear="true">
                <a-select-option v-for="(item, index, key) in cptCodeList" :value="item.text" :key="key">{{ item.text }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="8" :lg="24" :md="24" :xs="24" style="line-height:32px;marginBottom:16px">
          <a-row>
            <a-col :xs="labelCol.xs" :sm="labelCol.sm">币种:</a-col>
            <a-col :xs="wrapperCol.xs" :sm="wrapperCol.sm">
              <a-select placeholder="币种" v-model="loadParams.cexch_name" :allowClear="true">
                <a-select-option v-for="item in cexchList" :key="item.cexch_name" :value="item.cexch_name">{{ item.cexch_name }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row>
        <a-button-group style="float:right;margin-bottom:10px">
          <a-button icon="plus" v-if="$route.meta.toAddBill && invoice_show" @click="toKP" @success="toQuery">开票</a-button>
        </a-button-group>
      </a-row>
      <uto-table-new
        ref="desc"
        :columns="columns"
        :loadParams="loadParams"
        :url="queryUrl"
        :conditions="conditions"
        bordered
        :tableId="tableId"
        :rowSelection="{ onChange: onSelectChange, selectedRowKeys: selectedRowKeys }"
        rowKey="autoid"
      >
        <div slot="ddateR" slot-scope="flag">{{ date2string(flag) }}</div>
        <div slot="ipbvquantityR" slot-scope="flag, record">
          <a @click="toDetailPage(record)">{{ flag }}</a>
        </div>
      </uto-table-new>
    </list-page-view>
    <bill-add-module ref="bam" @addSucc="addSucc"></bill-add-module>
    <bill-confirm-detail-info ref="billconfirmdetailinfo"></bill-confirm-detail-info>
  </div>
</template>
<script>
import { scmApi, queryCurrency } from '@/api/scmApi'
import { findKPYWCGZXKPCTROL } from '@/api/public'
import moment from 'moment'
import BillAddModule from './module/BillAddModule'
import BillConfirmDetailInfo from './module/BillConfirmDetailInfo'
export default {
  name: 'BillNotice',
  components: {
    BillAddModule,
    BillConfirmDetailInfo
  },
  data() {
    return {
      userinfo: this.$store.getters.userinfo,
      cptCodeList: this.$store.getters.moduleEnums.scm.cptCode.data,
      tableId: 'BillNoticeTable',
      cexchList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultColumn: [
        // {
        //   title: '序号',
        //   dataIndex: 'temprownumber',
        //   noSorter: true,
        //   width: 80,
        //   align: 'center'
        // },
        {
          title: '日期',
          dataIndex: 'ddate',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'ddateR' }
        },
        {
          title: '单据编号',
          dataIndex: 'ccode',
          width: 150,
          align: 'center'
        },
        {
          title: '结算方式',
          dataIndex: 'ccashtype',
          width: 150,
          align: 'center'
        },
        {
          title: '部门名称',
          dataIndex: 'cdepname',
          width: 150,
          align: 'center'
        },
        {
          title: '业务员名称',
          dataIndex: 'cpersoncode',
          width: 150,
          align: 'center'
        },
        {
          title: '采购类型',
          dataIndex: 'cptname',
          width: 150,
          align: 'center'
        },
        {
          title: '供应商编码',
          dataIndex: 'cvencode',
          width: 150,
          align: 'center'
        },
        {
          title: '供应商名称',
          dataIndex: 'cvenname',
          width: 150,
          align: 'center'
        },
        {
          title: '供应商存货编码',
          dataIndex: 'cveninvcode',
          width: 150,
          align: 'center'
        },
        {
          title: '供应商存货名称',
          dataIndex: 'cveninvname',
          width: 150,
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'cinvcode',
          width: 150,
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'cinvname',
          width: 150,
          align: 'center'
        },

        {
          title: '规格型号',
          dataIndex: 'cinvstd',
          width: 150,
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'iquantity',
          width: 140,
          align: 'center'
        },
        {
          title: '主计量单位',
          dataIndex: 'cinvm_unit',
          width: 120,
          align: 'center'
        },
        {
          title: '开票数量',
          dataIndex: 'ipbvquantity',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'ipbvquantityR' }
        },
        {
          title: '可开票数量',
          dataIndex: 'inobillquantity',
          width: 120,
          align: 'center'
        },
        {
          title: '制单人',
          dataIndex: 'cmaker',
          width: 100,
          align: 'center'
        },
        {
          title: '币种',
          dataIndex: 'cexch_name',
          width: 100,
          align: 'center'
        },
        {
          title: '换算率',
          dataIndex: 'iinvexchrate',
          width: 100,
          align: 'center'
        },
        {
          title: '单位',
          dataIndex: 'cunitid',
          width: 100,
          align: 'center'
        },
        {
          title: '待确认发票数量',
          dataIndex: 'idqrquantity',
          width: 150,
          align: 'center'
        },
        {
          title: '单据状态',
          dataIndex: 'voucherstate',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项1',
          dataIndex: 'cdefine1',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项2',
          dataIndex: 'cdefine2',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项3',
          dataIndex: 'cdefine3',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项4',
          dataIndex: 'cdefine4',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项5',
          dataIndex: 'cdefine5',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项6',
          dataIndex: 'cdefine6',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项7',
          dataIndex: 'cdefine7',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项8',
          dataIndex: 'cdefine8',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项9',
          dataIndex: 'cdefine9',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项10',
          dataIndex: 'cdefine10',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项11',
          dataIndex: 'cdefine11',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项12',
          dataIndex: 'cdefine12',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项13',
          dataIndex: 'cdefine13',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项14',
          dataIndex: 'cdefine14',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项15',
          dataIndex: 'cdefine15',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项16',
          dataIndex: 'cdefine16',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项22',
          dataIndex: 'cdefine22',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项23',
          dataIndex: 'cdefine23',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项24',
          dataIndex: 'cdefine24',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项25',
          dataIndex: 'cdefine25',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项26',
          dataIndex: 'cdefine26',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项27',
          dataIndex: 'cdefine27',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项28',
          dataIndex: 'cdefine28',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项29',
          dataIndex: 'cdefine29',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项30',
          dataIndex: 'cdefine30',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项31',
          dataIndex: 'cdefine31',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项32',
          dataIndex: 'cdefine32',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项33',
          dataIndex: 'cdefine33',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项34',
          dataIndex: 'cdefine34',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项35',
          dataIndex: 'cdefine35',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项36',
          dataIndex: 'cdefine36',
          width: 150,
          align: 'center'
        },
        {
          title: '自定义项37',
          dataIndex: 'cdefine37',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项1',
          dataIndex: 'cfree1',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项2',
          dataIndex: 'cfree2',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项3',
          dataIndex: 'cfree3',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项4',
          dataIndex: 'cfree4',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项5',
          dataIndex: 'cfree5',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项6',
          dataIndex: 'cfree6',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项7',
          dataIndex: 'cfree7',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项8',
          dataIndex: 'cfree8',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项9',
          dataIndex: 'cfree9',
          width: 150,
          align: 'center'
        },
        {
          title: '自由项10',
          dataIndex: 'cfree10',
          width: 150,
          align: 'center'
        }
      ],
      columns: [],
      selectedRowKeys: [],
      selectedRows: [],
      loadParams: {
        voucherstate: '未开票'
      },
      queryUrl: '',
      dddate: null,
      conditions: {
        cinvcode: 'like_anywhere',
        cinvname: 'like_anywhere',
        cvencode: 'equal',
        cvenname: 'equal',
        cexch_name: 'like_anywhere',
        ccode: 'like_anywhere',
        cptname: 'like_anywhere',
        voucherstate: 'equal',
        ddate$1: 'large_equal',
        ddate$2: 'small_equal'
      },
      invoice_show: false
    }
  },
  created() {
    const _that = this
    _that.columns = _that.defaultColumn
    findKPYWCGZXKPCTROL().then(res => {
      if (res.code === 0 || res.code === '0') {
        if (res.data.cvalue == 1) {
          _that.invoice_show = true
        }
      }
    })
    this.getCexchList()
  },
  methods: {
    toDetailPage(record) {
      const _that = this
      if (record.ipbvquantity > 0) {
        _that.$refs.billconfirmdetailinfo.toAdd(record.autoid)
      } else {
        _that.$message.warning('暂无数据!')
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      const that = this
      if (selectedRows.length > 0) {
        const r = selectedRows[0]
        const target = selectedRows.filter(item => {
          if (
            item.cvencode !== r.cvencode ||
            item.cptcode !== r.cptcode ||
            item.purbilltype !== r.purbilltype ||
            item.iexchrate !== r.iexchrate ||
            item.itaxrate !== r.itaxrate ||
            item.cexch_name !== r.cexch_name
          ) {
            return true
          }
        })
        if (target.length > 0) {
          that.$message.warning('供应商、发票类型、采购类型、汇率、税率、币种与已选中行不一致，不能选择。')
        } else {
          that.selectedRowKeys = selectedRowKeys
          that.selectedRows = selectedRows
        }
      } else {
        that.selectedRowKeys = selectedRowKeys
        that.selectedRows = selectedRows
      }
    },
    selectColumnOK(data, base) {
      const that = this
      that.columns = []
      that.defaultColumn = base
      that.columns = JSON.parse(JSON.stringify(data))
    },
    toColumn() {
      this.$refs.dec.toSelectColumn(this.defaultColumn, this.tableId)
    },
    date2string(df) {
      if (df) {
        return moment(df).format('YYYY-MM-DD')
      } else {
        return undefined
      }
    },
    toQuery(searchText) {
      const that = this
      if (that.$store.getters.userinfo.cvencode) {
        that.loadParams['cvencode'] = that.$store.getters.userinfo.cvencode
      }
      if (!that.loadParams.cvencode || that.loadParams.cvencode === '') {
        that.$message.warning('请选择供应商!')
      } else {
        if (searchText) {
          that.loadParams['cinvname'] = searchText
        } else {
          that.loadParams['cinvname'] = ''
        }
        that.queryUrl = scmApi.queryBillNotice + '?t=' + parseInt(Math.random() * 1000)
      }
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    handleChange(dates, dateStrings) {
      const _that = this
      _that.loadParams['ddate$1'] = dateStrings[0] ? dateStrings[0] + ' 00:00:00' : ''
      _that.loadParams['ddate$2'] = dateStrings[1] ? dateStrings[1] + ' 23:59:59' : ''
    },
    toReset() {
      this.loadParams = {}
      this.dddate = null
      this.toQuery()
      this.resetSelect()
    },
    resetSelect() {
      const _that = this
      _that.selectedRowKeys = []
      _that.selectedRows = []
    },
    getCexchList() {
      queryCurrency()
        .then(res => {
          if (String(res.code) === '0') {
            this.cexchList = res.data
          } else {
            this.$message.error(res ? res.msg : '获取失败，请重试')
          }
        })
        .catch(err => {
          this.$message.error('获取失败，请重试')
        })
    },
    toKP() {
      const _that = this
      if (_that.selectedRows.length > 0) {
        this.$refs.bam.toAdd(_that.selectedRows)
        this.toQuery()
      } else {
        _that.$message.warn('请先选择数据!')
      }
    },
    addSucc() {
      this.toQuery()
    },
    toPrint() {
      const eConfig = {
        eFile: '开票通知单',
        dtf: 'kptzd',
        type: 'uprint'
      }
      this.$refs.desc.toPrint(eConfig)
    },
    STSelectedDataKeys(d) {
      if (d && d.length > 0) {
        const eConf = {
          eFile: '开票通知单'
        }
        eConf['type'] = '3'
        eConf['ids'] = d.join(',')
        eConf['col'] = 'autoid'
        this.$refs.desc.toExport(eConf)
      }
    },
    toExport(e) {
      const eConf = {
        eFile: '开票通知单'
      }
      if (e.key === 'all') {
        eConf['type'] = '1'
        this.$refs.desc.toExport(eConf)
      } else if (e.key === 'page') {
        eConf['type'] = '2'
        this.$refs.desc.toExport(eConf)
      } else {
        const zmColmuns = [
          {
            title: '单据编号',
            dataIndex: 'ccode',
            width: 150,
            align: 'center'
          },
          {
            title: '业务员名称',
            dataIndex: 'cpersoncode',
            width: 150,
            align: 'center'
          },
          {
            title: '采购类型',
            dataIndex: 'cptname',
            width: 150,
            align: 'center'
          },
          {
            title: '供应商名称',
            dataIndex: 'cvenname',
            width: 150,
            align: 'center'
          }
        ]
        const zmDATA = this.$refs.desc.getSD()
        this.$refs.dec.toSelectData(zmColmuns, zmDATA, 'autoid')
      }
    }
  }
}
</script>
